<template>
  <div class="about">
    <div class="about-left">
      <div class="about-left-content">
        <h4>Кои сме ние</h4>
        <p>
          cDots е компания с над 10 години опит в Европа и Азия. Ние сме група
          от компании с представителства в Лондон, Монреал, София и Истанбул.
          Компанията е създадена в края на 2010 и покрива пълния спектър от ИТ
          продукти и услуги в това число разработка на специализиран софутуер.
        </p>
        <p>
          Програмите, който създаваме намаляват разходите, спестяват средства и
          улесняват работата на предприятията. Ние не продаваме софтуерни
          лицензи – ние сме производител на програми с които клиентите ни
          печелят и се развиват. Ние създаваме успеха, ние реализираме
          амбициите. При работата с нас - клиентите са спокойни, успешни,
          продуктивни.
        </p>
        <p>
          Разработваме решения, които подпомагат бизнеса. Програми за
          производство, търговия, управление, анализи. За тези близо 10 години
          компанията ни има над 60 международни клиента, включващи малки и
          средни компании. Фирми от няколко човека персонал, през предприятия от
          така наречения Enterprise клас – опериращи на няколко континента
        </p>
        <div class="tabs">
          <div
            class="tab"
            :class="{ 'tab-active': activeTab === 0 }"
            @click="activeTab = 0"
          >
            Видео
            <br />Презентации
          </div>
          <div
            class="tab"
            :class="{ 'tab-active': activeTab === 1 }"
            @click="activeTab = 1"
          >
            Снимки
          </div>
          <div
            class="tab"
            :class="{ 'tab-active': activeTab === 2 }"
            @click="activeTab = 2"
          >
            Събития
          </div>
        </div>
        <div class="tab-content">
          <div
            class="content-row"
            v-for="(x, i) in content[activeTab]"
            :key="`item-${i}`"
            @click="activeTab === 1 ? openPhoto(x) : openVideo(x)"
          >
            <img
              :src="
                activeTab === 1
                  ? x.images[0]
                  : `/static/img/about/thumbnails/${x.id}.webp`
              "
              alt
            />
            <div class="content-texts">
              <p>{{ x.title }}</p>
              <p>{{ x.description }}</p>
            </div>
          </div>
        </div>
        <br />
        <!-- <img
          class="header-img"
          width="100%"
          height="auto"
          src="/static/img/eu.png"
          alt="Preview"
        /> -->
        <!-- <p>
          „СИ ДОТС ЕООД“ ЕООД стартира изпълнението на договор за безвъзмездна
          финансова помощ BG16RFOP002-2.073-25168-C01 по проект „Преодоляване
          недостига на средства и липсата на ликвидност, настъпили в резултат от
          епидемичния взрив от COVID-19”. Договорът е по процедура
          BG16RFOP002-2.073 „Подкрепа на микро и малки предприятия за
          преодоляване на икономическите последствия от пандемията COVID-19”
          финансиран от Оперативна програма „Иновации и конкурентоспособност”
          2014-2020, съфинансирана от Европейския съюз чрез Европейския фонд за
          регионално развитие.
        </p>
        <p>
          Целта на проекта е oсигуряване на оперативен капитал за справяне с
          последиците от пандемията COVID-19. Постигане на положителен ефект за
          преодоляване на икономическите последствия от пандемията COVID-19 и
          стабилност на работните места.
        </p>
        <p>
          Общата стойност на проекта е 10 000.00 лева, като размерът на
          безвъзмездната финансова помощ е 100%, от които 8500.00 лв. европейско
          и 1500.00 лв. национално съфинансиране.
        </p>
        <p>
          Проектът стартира на 30.09.2020 г. и е с продължителност 3 месеца.
        </p> -->
      </div>
    </div>
    <div class="about-right"></div>
    <img
      class="about-img-mobile"
      src="/static/img/about/about_m.png"
      alt="About us"
    />
    <transition name="fade">
      <Modal
        v-if="isModalOpened"
        :video="
          activeTab === 1
            ? null
            : `https://www.youtube.com/embed/${selectedVideo}`
        "
        :photos="activeTab === 1 ? selectedPhoto : null"
      />
    </transition>
  </div>
</template>

<script>
import sendInquiry from "./mixins/sendInquiry.js";
import Modal from "./shared/Modal";
export default {
  components: {
    Modal: Modal,
  },
  mixins: [sendInquiry],
  data() {
    return {
      isModalOpened: false,
      selectedVideo: "",
      selectedPhoto: {},
      activeTab: 0,
      content: [
        // VIDEOS
        [
          {
            id: "UI50wxIMyfE",
            title: "Оптимизиране работата на хората чрез технологиите",
            description:
              "Участие на управителя на Си Дотс Филип Дечев в ТВ +, Октомври 2017",
          },
          {
            id: "axUj4QUM6Qo",
            title:
              "Българска компания с уникален софтуер за решение на бизнес операциите",
            description:
              "Участие на управителя на Си Дотс Филип Дечев в ТВ Европа, 20 Октомври 2017",
          },
          {
            id: "Rv_Z-3U8c0I",
            title:
              "Представяне на ИТ отдела във фирма Си Дотс ЕООД от управителя",
            description:
              "Представяне на ИТ отдела във фирма Си Дотс ЕООД от управителя",
          },
          {
            id: "9lgpbgo4GdM",
            title: "Си Дотс - кратко представяне на фирмата от управителя",
            description:
              "Кратко представяне на фирма Си Дотс от нейния управител, за създаването до сега",
          },
        ],
        // PHOTOS
        [
          {
            images: [
              "/static/img/about/photos/0/1.webp",
              "/static/img/about/photos/0/2.webp",
              "/static/img/about/photos/0/3.webp",
              "/static/img/about/photos/0/4.webp",
              "/static/img/about/photos/0/5.webp",
              "/static/img/about/photos/0/6.webp",
              "/static/img/about/photos/0/7.webp",
            ],
            title: "Откриване на завод Одело край Пловдив",
            description:
              "Завод Отело беше изграден с помощта на софтуера за строителство и отчитане на СМР на фирма Си Дотс",
          },
          {
            images: [
              "/static/img/about/photos/1/1.webp",
              "/static/img/about/photos/1/2.webp",
              "/static/img/about/photos/1/3.webp",
            ],
            title: "Участие в Българо-Индийски Бизнес Форум",
            description:
              "Представяне дейността на фирмата, пред индийски компании в София, България",
          },
          {
            images: [
              "/static/img/about/photos/2/1.webp",
              "/static/img/about/photos/2/2.webp",
            ],
            title: "Фирмен живот",
            description: "Как протича работния процес",
          },
          {
            images: [
              "/static/img/about/photos/3/1.webp",
              "/static/img/about/photos/3/2.webp",
              "/static/img/about/photos/3/3.webp",
            ],
            title: "Първо представяне 2011г.",
            description:
              "Бизнес закуска с първите клиенти на Си Дотс - тогава с наименование НАБАКО България",
          },
          {
            images: [
              "/static/img/about/photos/4/1.webp",
              "/static/img/about/photos/4/2.webp",
              "/static/img/about/photos/4/3.webp",
              "/static/img/about/photos/4/4.webp",
            ],
            title: "Първата инвестиция на Си Дотс",
            description:
              " Първата ни инвестиция беше на по-голяма стойност от апартамента в който се помещавахме",
          },
          {
            images: [
              "/static/img/about/photos/5/1.webp",
              "/static/img/about/photos/5/2.webp",
              "/static/img/about/photos/5/3.webp",
              "/static/img/about/photos/5/4.webp",
              "/static/img/about/photos/5/5.webp",
              "/static/img/about/photos/5/6.webp",
              "/static/img/about/photos/5/7.webp",
            ],
            title: "Историята в картинки",
            description: "Фирмата стартира с едно бюро в празен офис",
          },
        ],
        // EVENTS
        [
          {
            id: "eUcCJrWNaCs",
            title:
              "Си Дотс – внедряване на нов продукт или експанзия в нова държава",
            description:
              "Лекция пред предприемачи от цялата страна, гр. Варна, 2018г. Филип Дечев – управител Си Дотс ЕООД като гост на Сдружение на Предприемачите „Лудогорие“",
          },
          {
            id: "cBdGrcs9XGM",
            title: "Си Дотс – иновации, кооперации, операции",
            description:
              "Лекция пред предприемачи от цялата страна, гр. Варна, 2017г. Филип Дечев – управител Си Дотс ЕООД като гост на Сдружение на Предприемачите „Лудогорие“",
          },
          {
            id: "aOPM3noQewY",
            title:
              "Speech by Chief Commercial Counsellor of the Embassy of the Republic of Turkey",
            description:
              "Event organized by cDots in Sofia for Turkish investor and kind participation of Commercial Counsellor of the Embassy of the Republic of Turkey",
          },
          {
            id: "rVes43y0uJA",
            title: "Си Дотс – представяне пред инвеститори от Турция",
            description:
              "Представяне пред инвеститори от Турция на семинар организиран от Си Дотс с участието на Търговското аташе на Р.Турция и посланици на търговски организации",
          },
          {
            id: "liw-hmkiBmo",
            title: "cDots – Presentation by cDots’ regional manager Caner Uzen",
            description:
              "Presentation of regional manager Caner Uzen in Bulgarian-Turkish Business Forum organized by cDots",
          },
          {
            id: "2gOOOoFz_x8",
            title: "Си Дотс подготовка за презентация",
            description:
              "cDots Ltd. presents its strategy for business development with partners from the Bulgarian-Turkish Industrial Chamber",
          },
          {
            id: "UJMtJRn3kVs",
            title: "Си Дотс – електронна търговия",
            description:
              "Лекция пред предприемачи от цялата страна, гр. Варна, 2016г. Филип Дечев – управител Си Дотс ЕООД като гост на Сдружение на Предприемачите „Лудогорие“",
          },
        ],
      ],
    };
  },
  methods: {
    openVideo(v) {
      this.selectedVideo = v.id;
      this.isModalOpened = true;
    },
    openPhoto(p) {
      this.selectedPhoto = p;
      this.isModalOpened = true;
    },
  },
  mounted() {
    this.$on("close-modal", () => {
      this.isModalOpened = false;
      this.selectedVideo = "";
      this.selectedPhoto = {};
    });
  },
  destroyed() {
    this.$off("close-modal");
  },
};
</script>

<style scoped>
.about-img-mobile {
  display: none;
}
.about {
  display: flex;
  height: 100vh;
  margin-top: -145px;
  min-height: 1px;
}

.header-img {
  mix-blend-mode: multiply;
}
/* LEFT */
.about-left {
  background-color: #f0f0f0;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 1px;
  padding: 160px 0 0 0;
  width: 50%;
}
.about-left-content {
  display: flex;
  flex-direction: column;
  padding: 0 50px 50px 100px;
  overflow: auto;
  height: 100%;
}
.about-left-content::-webkit-scrollbar {
  width: 5px;
}
/* Track */
.about-left-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
.about-left-content::-webkit-scrollbar-thumb {
  background: #888;
}
/* Handle on hover */
.about-left-content::-webkit-scrollbar-thumb:hover {
  background: #c9c9c9;
}
.about-left h4 {
  margin: 15px 0;
}
.about-left p {
  color: #000;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 20px;
}
.about-left ul {
  padding-left: 20px;
}
.about-left li {
  color: #000;
  font-size: 14px;
  line-height: 22px;
}
.tabs {
  display: flex;
  justify-content: center;
  margin: 15px 0;
  width: 100%;
}
.tab-content {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
}
.tab {
  align-items: center;
  background-color: #f8f8f8;
  border-radius: 4px;
  color: #3f3f3f;
  cursor: pointer;
  display: inline-flex;
  height: 60px;
  justify-content: center;
  line-height: 16px;
  margin-right: 20px;
  padding: 10px;
  text-align: center;
  width: 160px;
}
.tab:last-child {
  margin-right: 0;
}
.tab:hover {
  background-color: #c9c9c9;
}
.tab-active {
  background-color: #c9c9c9;
  font-weight: 700;
}
.content-row {
  align-items: flex-start;
  border-bottom: 1px solid #c9c9c9;
  cursor: pointer;
  display: flex;
  padding: 8px;
  width: 100%;
}
.content-row:first-child {
  border-top: 1px solid #c9c9c9;
}
.content-row img {
  border-radius: 4px;
  display: block;
  height: auto;
  margin-right: 20px;
  width: 140px;
}
.content-row .content-texts {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
}
.content-row .content-texts p {
  margin: 5px 0 0;
  line-height: 16px;
}
.content-row .content-texts p:last-child {
  opacity: 0.7;
  font-size: 13px;
}
.content-row:hover {
  background-color: rgba(201, 201, 201, 0.1);
}
/* RIGHT */
.about-right {
  align-items: center;
  background-image: url("/static/img/about/about.webp");
  background-size: cover;
  background-position: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 1px;
  padding: 160px 0 25px;
  width: 50%;
}
/* RESPONSIVE */
@media screen and (max-width: 1600px) {
  .about-left {
    padding-top: 140px;
  }
  .about-left p {
    margin-bottom: 15px;
  }
  .tabs {
    margin: 0 0 10px;
  }
  .tab {
    font-size: 13px;
    line-height: 12px;
    height: 45px;
    width: 140px;
  }
}
@media screen and (max-width: 1440px) {
  .about {
    margin-top: -100px;
  }
  .about-left p,
  .about-left li {
    font-size: 14px;
  }
  .about-left p {
    margin-bottom: 15px;
  }
  .content-row .content-texts p:last-child {
    font-size: 11px;
  }
}
@media screen and (max-width: 1280px) {
  .about {
    flex-direction: column;
    height: initial;
  }
  .about-left {
    min-height: initial;
    padding: 100px 50px 50px;
    width: 100%;
  }
  .about-right {
    display: none;
  }
  .about-img-mobile {
    display: block;
    width: 100%;
  }
  .about-showcase {
    padding: 0;
  }
  .about-right {
    padding: 50px 20px 63px;
  }
  .about-left-content {
    padding: 0;
    overflow: initial;
  }
}
@media screen and (max-width: 600px) {
  .about-left {
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .content-row {
    padding: 8px 0;
  }
  .content-row .content-texts p:last-child {
    font-size: 10px;
  }
  .tab:not(:last-child) {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue